<div class="row">
  <ng-content></ng-content>
  @if (state !== 'details' && !enableOneRestrictionOnly) {
    <button
      style="margin-inline-end: 5px"
      (click)="addNewRestriction($event)"
      pButton
      pRipple
      type="button"
      icon="pi pi-plus-circle"
      [label]="'COMMON.BUTTONS.ADD_NEW_RESTRICTION' | translate"
      class="p-button-text"
    ></button>
  }
</div>
<p-scrollPanel [ngStyle]="style" class="restrictons" [class.no-scroll]="enableOneRestrictionOnly">
  @for (restriction of selectedRestrictions; track trackByIdx(i, restriction); let i = $index) {
    <div
      class="row grid-sm restriction-container"
      [class.restriction-has-collision]="hasRestrictionCollision(restriction)"
      [class.has-collision-space]="hasRestrictionCollision(restriction)"
      >
      <div class="cell fg-1 fb-50">
        <div class="days-field-container">
          <!-- Collision Warning - positioned absolutely to prevent layout shifts -->
          <div class="collision-warning-overlay">
            @if (hasRestrictionCollision(restriction)) {
              <div class="alert alert-warning">
                <i class="pi pi-exclamation-triangle mr-5"></i>
                <span class="fw-600">{{ 'COMMON.FORMS.TIME_RESTRICTIONS.TIME_CONFLICT' | translate }}</span>
                <span class="collision-details">{{ getRestrictionCollisionMessage(restriction) }}</span>
              </div>
            }
          </div>
          @if (!useWorkPeriod) {
            <div class="form-group">
              @if (state !== 'details') {
                <label [for]="'daysInput' + restriction + i" class="form-label">{{ 'COMMON.DATE.DAYS' | translate }}</label>
              }
              @if (state === 'details') {
                <span class="form-label">{{ 'COMMON.DATE.DAYS' | translate }}</span>
              }
              @if (state === 'create' || state === 'edit') {
                <div [class]="inputsClass + ' p-input-icon-left'">
                  <p-multiSelect
                    appendTo="body"
                    [options]="dayList"
                    optionLabel="name"
                    optionValue="value"
                    [name]="'daysInput' + restriction + i"
                    [filter]="false"
                    [formControl]="getRestrictionFormControl(restriction, 'daysWeek')"
                    [showHeader]="false"
                    [placeholder]="'COMMON.DATE.DAYS' | translate"
                    [inputId]="'daysInput' + restriction + i"
                    (onChange)="dayListValueChanges($event, restriction)"
                    >
                  </p-multiSelect>
                </div>
              }
              @if (state === 'details') {
                <div>
                  @for (dayOfWeek of restriction.daysWeek; track dayOfWeek) {
                    <h3 class="fw-500 no-mg">
                      {{ dayOfWeek.name }}
                    </h3>
                  }
                </div>
              }
            </div>
          }
          @if (useWorkPeriod) {
            <app-invitation-calendar
              [model]="modelDates"
              labelClass="fz-14"
              label="ORDERS.FORMS.FIELD_LABELS.DATE_OF_SERVICE"
              [class]="inputsClass + ' fg-1 fz-11'"
              firstDateFormControlName="from"
              secondDateFormControlName="to"
              [firstDatePlaceholder]="'SUBSCRIBERS.FORMS.PLACEHOLDERS.SUBSCRIBER_START' | translate"
              [secondDatePlaceholder]="'SUBSCRIBERS.FORMS.PLACEHOLDERS.SUBSCRIBER_END' | translate"
              (modelChange)="onDatesChange($event, restriction.formControl)"
            ></app-invitation-calendar>
          }
        </div>
      </div>
      <div class="cell fg-1 fb-40">
        <div [class.row]="state !== 'details'" [class.row-inline]="state === 'details'" [style.gap]="state !== 'details' ? '5px' : '20px'">
          <!-- The start/finish pair follows the page direction: `direction: ltr` here used to flip them, so a Hebrew reader saw the finish time first.
               Only the masked inputs are forced to ltr (see the dir="ltr" wrappers below) — a half-typed "18:__" is reordered by bidi otherwise. -->
          <div [class.row]="state !== 'details'" [class.row-inline]="state === 'details'" [style.gap]="state !== 'details' ? '5px' : '20px'" style="width: 100%">
            <div class="form-group fw-40">
              @if (state !== 'details') {
                <label [for]="'hoursInputR1' + restriction + i" class="form-label">{{ 'SHARED.START_TIME' | translate }}</label>
              }
              @if (state === 'details') {
                <span class="form-label">{{ 'SHARED.START_TIME' | translate }}</span>
              }
              @if (state !== 'details') {
                <div dir="ltr" [class]="inputsClass + ' p-input-icon-right fg-1 fw-100'">
                  <p-inputMask
                    mask="99:99"
                    [ngModel]="!useWorkPeriod ? selectedRestrictions[i].hourFirstRange : selectedRestrictions[i].daily_work_from"
                    (ngModelChange)="!useWorkPeriod ? selectedRestrictions[i].hourFirstRange : (selectedRestrictions[i].daily_work_from = $event)"
                    [inputId]="'hoursInputR1' + restriction + i"
                    placeholder="HH:mm"
                    [formControl]="$any(getRestrictionFormControl(restriction, !useWorkPeriod ? 'hourFirstRange' : 'daily_work_from'))"
                  ></p-inputMask>
                  <i class="pi icon-time icon color-primary"></i>
                </div>
              }
              @if (state === 'details') {
                <div>
                  <h3 class="fw-500 no-mg">
                    {{ restriction.hourFirstRange | date: 'HH:mm' }}
                  </h3>
                </div>
              }
            </div>
            <div class="form-group fw-40">
              @if (state !== 'details') {
                <label [for]="'hoursInputR2' + restriction + i" class="form-label">{{ 'SHARED.FINISH_TIME' | translate }} </label>
              }
              @if (state === 'details') {
                <span class="form-label">{{ 'SHARED.FINISH_TIME' | translate }} </span>
              }
              @if (state !== 'details') {
                <div dir="ltr" [class]="inputsClass + ' p-input-icon-right fg-1  fw-100'">
                  <p-inputMask
                    mask="99:99"
                    [ngModel]="!useWorkPeriod ? selectedRestrictions[i].hourSecondRange : selectedRestrictions[i].daily_work_to"
                    (ngModelChange)="!useWorkPeriod ? selectedRestrictions[i].hourSecondRange : (selectedRestrictions[i].daily_work_to = $event)"
                    [inputId]="'hoursInputR2' + restriction + i"
                    placeholder="HH:mm"
                    [formControl]="$any(getRestrictionFormControl(restriction, !useWorkPeriod ? 'hourSecondRange' : 'daily_work_to'))"
                  ></p-inputMask>
                  <i class="pi icon-time icon color-primary"></i>
                </div>
              }
              @if (state === 'details') {
                <div>
                  <h3 class="fw-500 no-mg">
                    {{ restriction.hourSecondRange | date: 'HH:mm' }}
                  </h3>
                </div>
              }
            </div>
          </div>
          @if (useWorkPeriod && workPeriodEstimatedFeeShow) {
            <div class="row" style="width: 100%; margin-inline-start: 5px">
              <app-yabi-input
                type="number"
                [form]="restriction.formControl"
                [class]="inputsClass"
                formControlNameInput="estimated_fee"
                label="ORDERS.FORMS.FIELD_LABELS.ESTIMATED_FEE"
                class="fw-100"
                [id]="'estimated_fee' + restriction + i"
              ></app-yabi-input>
            </div>
          }
          <ng-container *ngTemplateOutlet="otherRender; context: { other: restriction }"></ng-container>
        </div>
      </div>
      <div class="cell fg-1 fb-10">
        @if (state !== 'details' && !enableOneRestrictionOnly) {
          <button type="button" (click)="onDeleteRestriction($event, restriction)" class="btn btn-danger-link active fg-1">
            <i aria-hidden="true" class="pi pi-trash"></i>
          </button>
        }
      </div>
    </div>
  }
</p-scrollPanel>
